import { SettingDefinition } from '@120wateraudit/envirio-components/dist/models'
import CrudActions, { ICrudActions } from 'src/actions/helpers/CrudActions'

const actions: ICrudActions = CrudActions<SettingDefinition>({
  entityName: 'labPartner',
  collectionName: 'labPartners'
})

export default actions
